<template>
  <div>
    <!--页面小于750px是使用的公共底部-->
    <ul class="PheadDown">
      <li>
        <router-link to="/home" active-class="selected"><span>トップページ</span></router-link>
      </li>
      <li>
        <router-link to="/brand" active-class="selected"><span>会社情報</span></router-link>
      </li>
      <li>
        <router-link to="/404" active-class="selected"><span>買い物かご</span></router-link>
      </li>
      <li>
        <router-link to="/404" active-class="selected"><span>個人情報</span></router-link>
      </li>
    </ul>
  </div>
</template>

<script>
  import {getUserInfo} from './../../api/interface/users';
  import Footer from './Footer.vue'
  import {bus} from '../../main'
  export default{
    name: "",
    data(){
      return {
        msg: "",
      }
    },
    beforeMount(){
    },
    methods: {
    },
    components: {
    }
  }
</script>
<style lang="scss">
  @import "../../../static/pubilc";
  @media screen and(min-width: $min-screen) and(max-width: $P749screen) {
    .PheadDown {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      height: 50px;
      width: 100%;
      display: flex;
      justify-content: space-around;
      line-height: 50px;
      text-align: center;
      font-size: 14/$default-w+rem;
      background-color: white;
      li {
        width: 25%;
        border-top: 1px solid #f0f0f0;
        border-bottom: 1px solid #f0f0f0;
        border-right: 1px solid #f0f0f0;
      }
      li:nth-child(4) {
        border-right: none;
      }
      a {
        color: #6f7180;
        letter-spacing: 1px;
        text-decoration: none;
      }
      .selected > span {
        color: $navcolor;
      }
    }
  }
  @media screen and(min-width: $P750screen){
    .PheadDown{
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/common/mhead.vue